import axios from "axios";
import React, { Component } from "react";
import Spinner from 'helpers/Spinner'
import SectionLoading from 'componentes/templates/mainsection/components/SectionLoading'
import { connect } from "react-redux";
import {set_datapage} from 'redux/actions/DataPageAction'

import helperStorage from "./helperStorage";
import storeImport, { import_current_tab } from "./store";
import { Provider } from 'react-redux'
import ImportFileStep1 from "./ImportFileStep1";
import ImportFileStep2 from "./ImportFileStep2";
import ImportFileStep3 from "./ImportFileStep3";
import { GET } from 'helpers/request'
import LanguageHelper from 'helpers/language_helper'

class ImportFiles extends Component {
    requestInit = null;
    // successInit = false
    state = {
        fileExists: false,
        count: 0,
        txtNombres: '',
        txtApellidos: '',
        list: [],
        successInit: true,
        currentTab: 1,
        collectTabs: [1],
        filterType: []
    }
    constructor (props) {
        super(props)
        
        this.requestInit = axios.CancelToken.source()

        this.props.set_datapage({ 
            titulo: 'Importar archivos desde Excel o CSV',
            isbackend:true,
            be_itemselect:"rec_importar_excel",//clave de item del menu backend que se debe activar 
            breadcrumb:[
                {name:"Intranet",url:"#"},
                {name:"Importar Archivo",url:"#"},
                {name:"Importar",url:"#"},
                {name:"Importar archivos desde Excel o CSV",url:"#",active:true},
            ]});
        
        
        // this.setState({filterType})


    }
    
    COptionTypeInformation = (currentOption = -1) =>  (   
            this.state.list.map((item, index) => <option key={index} value={ item.value }>{ item.name}</option>)
    )
     
    
    // COptionTypeInformation = () => {
    //     return (
    //         this.state.list.map((item, index) => {
    //             return <option key = {index} value=""> Casa </option>
    //         })
    //     )
    // }
    checkFile = () => {
        let frmCheck = new FormData()

        frmCheck.append('tempid', helperStorage.getID())
        frmCheck.append('tempfile', helperStorage.getFileName())
        axios.post(`${process.env.REACT_APP_BASE_BASE_URL}cites/import/file/checktempfile`, frmCheck,  { cancelToken: this.requestInit.token }).then(res => {

            if (!res.data.success) {
                helperStorage.clear()
                storeImport.dispatch(import_current_tab(1))
            } else {
                this.setState({
                    fileExists: res.data.success
                })
                storeImport.dispatch(import_current_tab(2))
            }
        })
    }
    componentWillUnmount () {
        // console.log('DIE Importar Main')
        console.log(storeImport)
        // if (storeImport) storeImport.unsubscribe()
        this.unsubscribeStoreImport()
        if (this.requestInit) this.requestInit.cancel()

    }
    unsubscribeStoreImport = (cosa, b) => {
        
        // console.log('Change subscribe Import Store', storeImport.getState())
        if (+storeImport.getState().reducerTab.tab !== this.state.currentTab) {
            console.log('VIENES', storeImport.getState().reducerTab)
            this.setState({
                currentTab: +storeImport.getState().reducerTab.tab,
                collectTabs: storeImport.getState().reducerTab.targets
            })
            
            this.showHideTabs(+storeImport.getState().reducerTab.tab)
        }
    }
    componentDidMount() {
        storeImport.subscribe(this.unsubscribeStoreImport);
        //check lidtemp
        this.setState({
            currentTab: storeImport.getState().reducerTab.tab
        })
        this.showHideTabs(storeImport.getState().reducerTab.tab)
        // Spinner.show()
        // this.checkFile()
        
        let qImport = new URLSearchParams(this.props.location.search).get('imports')
        if (qImport)
            qImport.split(',').filter(q => q)
        
        const fetcher = async () => {
                await GET(`/indicators/optionThematics`).then(res => {
                    console.log(res)
                    this.setState({
                        list: res.datos,
                        successInit: false
                    })
    
                    Spinner.hide()
                   
                })
                
              };
        fetcher();

        
    }
    // changeTextNameFile = ()
    onChange = (evt) => {
        const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
        
        if (evt.target.name === 'file-doc') {
            //change name curretn file
            let tn = 'Buscar'
            if (evt.target.files[0]) {
                tn = evt.target.files[0].name
            }
            this.setState({
                nameCurrentFile: tn
            })
        }

        this.setState({
          [evt.target.name]: value,
        });
    }
    showHideTabs = (tab = 0) => {
        console.log('showHideTabs', tab)
        let tabs = document.getElementById('containerTabs')
        if (tabs) {
            for (let index = 0; index < tabs.childElementCount; index++) {   
                if (tabs.children.item(index).id === 'tab' + tab) {
                    tabs.children.item(index).classList.remove('is-hidden')
                } else {
                    tabs.children.item(index).classList.add('is-hidden')
                }
            }
        }
    }
    changeTab = (event, tab = 0) => {
        
        event.preventDefault()
        console.log(event, this.state.collectTabs,'jj')
        
        // let tab = 0;
            if (event.target.tagName.toString().toLowerCase() === 'a') {
                tab = event.target.dataset.tab
            } else {
                tab = event.target.offsetParent.dataset.tab
            }
            
            // this.setState({
                //     currentTab: tab
                // })
        if (this.state.collectTabs.includes(+tab)) {
            console.log('gggggggggggggggggg', tab)
            this.showHideTabs(tab)
            storeImport.dispatch(import_current_tab(tab))
        }
    }
    

    render() {
        return (
            <Provider store={ storeImport }>
                <section className="section is-main-section">

                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                {LanguageHelper.getLanguageString('ImportIndicators.title')}
                            </p>
                        </header>
                        <div className="card-content">
                        <div id="spinnerDefault" className="spinnerDefault">
      <div className="ld ld-spin  ld-spinner"></div>
      <div className="spinner"></div>
    </div>
                            <SectionLoading show={ this.state.successInit }>
                                <div className="tabs is-toggle is-toggle-rounded">
                                    <ul>
                                        <li className={ +this.state.currentTab === 1 ? "is-active" : '' }>
                                            <a href="/#" data-tab="1" onClick={this.changeTab}>
                                                <span className="icon is-small"><i className="fas fa-bookmark"></i></span>
                                                <span>{LanguageHelper.getLanguageString('ImportIndicators.step1')}</span>
                                            </a>
                                        </li>
                                        <li className={ +this.state.currentTab === 2 ? "is-active" : '' }>
                                            <a href="/#" data-tab="2" onClick={this.changeTab}>
                                                <span className="icon is-small"><i className="fas fa-bookmark"></i></span>
                                                <span>{LanguageHelper.getLanguageString('ImportIndicators.step2')}</span>
                                            </a>
                                        </li>
                                        <li className={ this.state.currentTab === 3 ? "is-active" : '' }>
                                            <a href="/#" data-tab="3" onClick={this.changeTab}>
                                                <span className="icon is-small"><i className="fas fa-bookmark"></i></span>
                                                <span>{LanguageHelper.getLanguageString('ImportIndicators.step3')}</span>
                                            </a>
                                        </li>
                                      
                                    </ul>
                                </div>
                                <div id="containerTabs" className="container-tab">
                                <ImportFileStep1  id="tab1" COptionTypeInformation={this.COptionTypeInformation()}></ImportFileStep1>
                                <ImportFileStep2 className="is-hidden" id="tab2"></ImportFileStep2>
                                <ImportFileStep3 className="is-hidden" id="tab3"></ImportFileStep3>
                                </div>
                            </SectionLoading>
                        </div>
                    </div>
                </section>


            </Provider>
        )
    }
}


// const mapStateToProps = (state /*, ownProps*/) => {
//     console.log('xxxxxxxxxxxxxxxxxxxx', state)
//     return {
//       currentTab: state,
//     }
//   }
export default connect(null, {set_datapage})(ImportFiles)